import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { 
  Button, Table, Tag, Tooltip, Row, Col, Card, Statistic, DatePicker, Select, Input, 
  Space as AntSpace, message 
} from 'antd';
import { 
  UserOutlined, TeamOutlined, SettingOutlined, 
  SafetyCertificateOutlined, DashboardOutlined, 
  ExportOutlined, DeleteOutlined, EyeOutlined,
  SearchOutlined, DownloadOutlined, LineChartOutlined,
  WarningOutlined, InfoCircleOutlined, CloseCircleOutlined,PlayCircleOutlined
} from '@ant-design/icons';

import HwzComponent from '../../common/component/HwzComponent';
import Pager from '../../common/model/base/Pager';
import SortDirection from '../../common/model/base/SortDirection';
import SystemLog, { 
  SystemLogModule, 
  SystemLogOperation, 
  SystemLogTargetType,
  SystemLogType,
  SystemLogAlarmLevel 
} from '../../common/model/syslog/SystemLog';
import Lang from '../../common/model/global/Lang';
import DateUtil from '../../common/util/DateUtil';
import './SystemLogList.less';
import { ColumnProps } from 'antd/lib/table';
import TableEmpty from '../widget/TableEmpty';
import FilterPanel from '../widget/filter/FilterPanel';
import { Modal } from 'antd'; // 添加导入

const { RangePicker } = DatePicker;
const { Option } = Select;

interface IProps extends RouteComponentProps {}
interface IState {
  statistics: any;
  loadingStatistics: boolean;
  exportLoading: boolean;
  cleanLoading: boolean;
  moduleList: Array<{value: string, label: string}>;
  operationList: Array<{value: string, label: string}>;
  detailVisible: boolean;
  currentDetail: string;
  currentLog: SystemLog | null;
}

export default class SystemLogList extends HwzComponent<IProps, IState> {
  pager = new Pager<SystemLog>(this, SystemLog, 20);

  constructor(props: IProps) {
    super(props);
    
    this.state = {
      statistics: {},
      loadingStatistics: false,
      exportLoading: false,
      cleanLoading: false,
      moduleList: [],
      operationList: [],
      detailVisible: false,
      currentDetail: '',
      currentLog: null,
    };
    
    // 初始化筛选条件
    this.pager.setFilterValue('orderCreateTime', SortDirection.DESC);
    this.pager.setFilterValue('orderDir', SortDirection.DESC);
  }
// 关闭详情模态框
handleCloseDetail = () => {
    this.setState({
      detailVisible: false,
      currentDetail: '',
      currentLog: null
    });
  }
// 添加查看详情的方法
handleViewDetail = (record: SystemLog) => {
    this.setState({
      detailVisible: true,
      currentDetail: record.detail,
      currentLog: record
    });
  }
  refreshPager() {
    // 确保筛选条件被正确应用
    
    this.pager.httpList();
  }
  loadStatistics() {
    this.setState({ loadingStatistics: true });
    
    const systemLog = new SystemLog();
    systemLog.httpStatistics(30,
      (response: any) => {
        console.log('=== 统计接口成功回调被调用 ===');
        console.log('完整响应对象 (response):', response);
        
        // 尝试多种可能的数据路径，优先取 response.data.data（标准包装）
        let stats = response?.data?.data;   // 标准包装 { code, msg, data: {...} }
        if (!stats) stats = response?.data;  // 直接返回数据
        if (!stats) stats = response;        // 降级
        
        console.log('最终统计对象 stats:', stats);
        
        const rawModuleStats = stats?.moduleStats || stats?.ModuleStats || [];
        const rawRecentAlarms = stats?.recentAlarms || stats?.RecentAlarms || [];
        
        console.log('原始 recentAlarms 长度:', rawRecentAlarms.length);
        
        // 确保 alarmLevel 为数字（后台已返回数字，但保留转换）
        const normalizedRecentAlarms = rawRecentAlarms.map((log: any) => {
          let alarmLevelNum = log.alarmLevel;
          if (typeof alarmLevelNum === 'string') {
            const map: { [key: string]: number } = {
              'none': 0, 'warning': 1, 'error': 2, 'critical': 3,
              'NONE': 0, 'WARNING': 1, 'ERROR': 2, 'CRITICAL': 3
            };
            alarmLevelNum = map[alarmLevelNum] ?? 0;
          } else if (typeof alarmLevelNum !== 'number') {
            alarmLevelNum = 0;
          }
          return { ...log, alarmLevel: alarmLevelNum };
        });
        
        const normalizedStats = {
          moduleStats: rawModuleStats,
          recentAlarms: normalizedRecentAlarms,
          period: stats?.period || stats?.Period || 30
        };
        
        console.log('归一化后的统计数据:', normalizedStats);
        console.log('警告数量:', normalizedStats.recentAlarms.filter((l: any) => l.alarmLevel === 1).length);
        console.log('错误数量:', normalizedStats.recentAlarms.filter((l: any) => l.alarmLevel === 2).length);
        
        this.setState({
          statistics: normalizedStats,
          loadingStatistics: false
        });
      },
      (error: any) => {
        console.error('统计接口失败:', error);
        this.setState({ loadingStatistics: false });
      }
    );
  }
  componentDidMount() {
    // 先设置静态数据
    this.setState({
      moduleList: SystemLog.getModuleOptions(),
      operationList: SystemLog.getOperationOptions()
    });
    
    // 然后刷新数据
    this.refreshPager();
    this.loadStatistics();
    
    // 尝试从后台获取数据（可选）
    this.tryLoadFromBackend();
  }
  
  tryLoadFromBackend() {
    const systemLog = new SystemLog();
    
    // 添加请求参数和回调
    systemLog.httpModules(
      (response: any) => {
        console.log('模块列表接口返回:', response);
        if (response && response.data && Array.isArray(response.data)) {
          this.setState({ moduleList: response.data });
        }
      },
      (error: any) => {
        console.error('获取模块列表失败:', error);
        // 保持使用静态数据
      }
    );
    
    systemLog.httpOperations(
      (response: any) => {
        console.log('操作列表接口返回:', response);
        if (response && response.data && Array.isArray(response.data)) {
          this.setState({ operationList: response.data });
        }
      },
      (error: any) => {
        console.error('获取操作列表失败:', error);
        // 保持使用静态数据
      }
    );
  }
  // 修改 loadModuleList 方法，使用静态方法作为后备
  loadModuleList() {
    const systemLog = new SystemLog();
    systemLog.httpModules((response: any) => {
      console.log('模块列表接口返回:', response);
      
      let moduleList = [];
      if (response && response.data && Array.isArray(response.data)) {
        moduleList = response.data;
      }
      
      console.log('接口模块列表:', moduleList);
      
      // 如果接口返回空或失败，使用静态方法获取
      this.setState({
        moduleList: moduleList.length > 0 ? moduleList : SystemLog.getModuleOptions()
      });
    }, (error: any) => {
      console.error('获取模块列表失败:', error);
      // 如果接口失败，使用静态方法获取
      this.setState({
        moduleList: SystemLog.getModuleOptions()
      });
    });
  }
  
// 同样修改 loadOperationList
loadOperationList() {
    const systemLog = new SystemLog();
    systemLog.httpOperations((response: any) => {
      console.log('操作列表接口返回:', response);
      
      let operationList = [];
      if (response && response.data && Array.isArray(response.data)) {
        operationList = response.data;
      }
      
      console.log('接口操作列表:', operationList);
      
      this.setState({
        operationList: operationList.length > 0 ? operationList : SystemLog.getOperationOptions()
      });
    }, (error: any) => {
      console.error('获取操作列表失败:', error);
      this.setState({
        operationList: SystemLog.getOperationOptions()
      });
    });
  }
  
  // 您也可以删除 getDefaultModuleList 和 getDefaultOperationList 方法
  // 因为它们的功能已经被 SystemLog.getModuleOptions() 和 SystemLog.getOperationOptions() 替代


// 获取默认模块列表
getDefaultModuleList(): Array<{value: string, label: string}> {
    return [
      { value: SystemLogModule.AUTH, label: Lang.t('systemLog.moduleAuth') },
      { value: SystemLogModule.USER, label: Lang.t('systemLog.moduleUser') },
      { value: SystemLogModule.DEPARTMENT, label: Lang.t('systemLog.moduleDepartment') },
      { value: SystemLogModule.SPACE, label: Lang.t('systemLog.moduleSpace') },
      { value: SystemLogModule.SYSTEM, label: Lang.t('systemLog.moduleSystem') },
      { value: SystemLogModule.ROLE, label: Lang.t('systemLog.moduleRole') },
      { value: SystemLogModule.LOG, label: Lang.t('systemLog.moduleLog') },
      { value: SystemLogModule.BACKUP, label: Lang.t('systemLog.moduleBackup') },
      { value: SystemLogModule.ALARM, label: Lang.t('systemLog.moduleAlarm') },
      // 添加缺失的模块
      { value: SystemLogModule.SHARE, label: Lang.t('systemLog.moduleShare') },
      { value: SystemLogModule.SYNC, label: Lang.t('systemLog.moduleSync') },
      { value: SystemLogModule.OTHER, label: Lang.t('systemLog.moduleOther') },
      { value: SystemLogModule.FILE, label: Lang.t('systemLog.moduleFile') },
      { value: SystemLogModule.SECURITY, label: Lang.t('systemLog.moduleSecurity') },
      { value: SystemLogModule.STORAGE, label: Lang.t('systemLog.moduleStorage') },
    ];
  }

// 获取默认操作列表
getDefaultOperationList(): Array<{value: string, label: string}> {
    return [
      { value: SystemLogOperation.LOGIN, label: Lang.t('systemLog.operationLogin') },
      { value: SystemLogOperation.LOGOUT, label: Lang.t('systemLog.operationLogout') },
      { value: SystemLogOperation.LOGIN_FAILED, label: Lang.t('systemLog.operationLoginFailed') },
      { value: SystemLogOperation.CREATE, label: Lang.t('systemLog.operationCreate') },
      { value: SystemLogOperation.UPDATE, label: Lang.t('systemLog.operationUpdate') },
      { value: SystemLogOperation.DELETE, label: Lang.t('systemLog.operationDelete') },
      { value: SystemLogOperation.ENABLE, label: Lang.t('systemLog.operationEnable') },
      { value: SystemLogOperation.DISABLE, label: Lang.t('systemLog.operationDisable') },
      { value: SystemLogOperation.RESET_PASSWORD, label: Lang.t('systemLog.operationResetPassword') },
      { value: SystemLogOperation.CHANGE_PASSWORD, label: Lang.t('systemLog.operationChangePassword') },
      { value: SystemLogOperation.IMPORT, label: Lang.t('systemLog.operationImport') },
      { value: SystemLogOperation.EXPORT, label: Lang.t('systemLog.operationExport') },
      // 添加缺失的操作类型
      { value: SystemLogOperation.BATCH_CREATE, label: Lang.t('systemLog.operationBatchCreate') },
      { value: SystemLogOperation.BATCH_DELETE, label: Lang.t('systemLog.operationBatchDelete') },
      { value: SystemLogOperation.BATCH_UPDATE, label: Lang.t('systemLog.operationBatchUpdate') },
      { value: SystemLogOperation.TRANSFIGURATION, label: Lang.t('systemLog.operationTransfiguration') },
      { value: SystemLogOperation.SCAN, label: Lang.t('systemLog.operationScan') },
      { value: SystemLogOperation.SYNC, label: Lang.t('systemLog.operationSync') },
      { value: SystemLogOperation.EXECUTE, label: Lang.t('systemLog.operationExecute') },
      { value: SystemLogOperation.BACKUP, label: Lang.t('systemLog.operationBackup') },
      { value: SystemLogOperation.RESTORE, label: Lang.t('systemLog.operationRestore') },
      { value: SystemLogOperation.CLEAN, label: Lang.t('systemLog.operationClean') },
      { value: SystemLogOperation.CONFIG_UPDATE, label: Lang.t('systemLog.operationConfigUpdate') },
      { value: SystemLogOperation.ROLE_ASSIGN, label: Lang.t('systemLog.operationRoleAssign') },
      { value: SystemLogOperation.PERMISSION_GRANT, label: Lang.t('systemLog.operationPermissionGrant') },
      { value: SystemLogOperation.PERMISSION_REVOKE, label: Lang.t('systemLog.operationPermissionRevoke') },
    ];
  }

  getAllFilterValues() {
    // 获取所有筛选条件
    const filters: any = {};
    
    // 从 pager 中获取各个筛选值
    const filterKeys = [
      'module', 'operation', 'logType', 'alarmLevel', 
      'username', 'keyword', 'startTime', 'endTime'
    ];
    
    filterKeys.forEach(key => {
      filters[key] = this.pager.getFilterValue(key);
    });
    
    return filters;
  }
  
  handleSearch = () => {
    console.log('搜索条件:', this.getAllFilterValues());
    this.pager.page = 0;
    this.refreshPager();
  }

  handleReset = () => {
    this.pager.resetFilter();
    this.refreshPager();
  }

  // 导出日志
  handleExport = () => {
    this.setState({ exportLoading: true });
    
    const params = this.buildExportParams();
    
    const systemLog = new SystemLog();
    systemLog.httpExport(params, () => {
      this.setState({ exportLoading: false });
      message.success(Lang.t('systemLog.exportSuccess'));
    }, (error: any) => {
      this.setState({ exportLoading: false });
      message.error(Lang.t('systemLog.exportFailed'));
      console.error('导出失败:', error);
    });
  }

  handleClean = () => {
    const keepDays = 90;
    
    // 手动替换占位符
    let confirmMessage = Lang.t('systemLog.cleanConfirm');
    confirmMessage = confirmMessage.replace('{keepDays}', keepDays.toString());
    
    // 或者使用模板字符串
    // const confirmMessage = `确认要清理${keepDays}天前的系统日志吗？`;
    
    if (!window.confirm(confirmMessage)) {
      return;
    }
    
    this.setState({ cleanLoading: true });
    
    const systemLog = new SystemLog();
    systemLog.httpClean(keepDays, (response: any) => {
      this.setState({ cleanLoading: false });
      message.success(response.message || Lang.t('systemLog.cleanSuccess'));
      this.refreshPager();
      this.loadStatistics();
    }, (error: any) => {
      this.setState({ cleanLoading: false });
      message.error(Lang.t('systemLog.cleanFailed'));
      console.error('清理失败:', error);
    });
  }

  // 构建导出参数
  buildExportParams(): any {
    const params: any = {};
    
    const filterKeys = [
      'username', 'module', 'operation', 'targetType', 
      'targetName', 'logType', 'alarmLevel', 'ip', 'keyword',
      'startTime', 'endTime'
    ];
    
    filterKeys.forEach(key => {
      const value = this.pager.getFilterValue(key);
      if (value !== null && value !== '' && value !== undefined) {
        params[key] = value;
      }
    });
    
    return params;
  }

  // 渲染操作图标
  renderOperationIcon(operation: string): React.ReactNode {
    const iconMap: { [key: string]: React.ReactNode } = {
      [SystemLogOperation.LOGIN]: <UserOutlined />,
      [SystemLogOperation.LOGOUT]: <UserOutlined />,
      [SystemLogOperation.LOGIN_FAILED]: <WarningOutlined />,
      [SystemLogOperation.CREATE]: <InfoCircleOutlined />,
      [SystemLogOperation.UPDATE]: <SettingOutlined />,
      [SystemLogOperation.DELETE]: <DeleteOutlined />,
      [SystemLogOperation.ENABLE]: <InfoCircleOutlined />,
      [SystemLogOperation.DISABLE]: <WarningOutlined />,
      [SystemLogOperation.RESET_PASSWORD]: <SafetyCertificateOutlined />,
      [SystemLogOperation.CONFIG_UPDATE]: <SettingOutlined />,
      [SystemLogOperation.EXECUTE]: <PlayCircleOutlined />,
    };
    return iconMap[operation] || <InfoCircleOutlined />;
  }

  // 渲染模块图标
  renderModuleIcon(module: string): React.ReactNode {
    const iconMap: { [key: string]: React.ReactNode } = {
      [SystemLogModule.AUTH]: <SafetyCertificateOutlined />,
      [SystemLogModule.USER]: <UserOutlined />,
      [SystemLogModule.DEPARTMENT]: <TeamOutlined />,
      [SystemLogModule.SPACE]: <DashboardOutlined />,
      [SystemLogModule.SYSTEM]: <SettingOutlined />,
      [SystemLogModule.ROLE]: <SafetyCertificateOutlined />,
      [SystemLogModule.LOG]: <EyeOutlined />,
      [SystemLogModule.BACKUP]: <DownloadOutlined />,
      [SystemLogModule.ALARM]: <WarningOutlined />,
    };
    return iconMap[module] || <InfoCircleOutlined />;
  }

  // 渲染统计卡片
  renderStatistics() {
    const { statistics, loadingStatistics } = this.state;
    
    if (!statistics || Object.keys(statistics).length === 0) {
      return null;
    }

    return (
      <Card className="statistics-card mb20" loading={loadingStatistics}>
        <Row gutter={16}>
          <Col span={6}>
            <Statistic
              title={Lang.t('systemLog.statisticsTotalOperations')}
              value={statistics.moduleStats?.reduce((sum: number, item: any) => sum + item.count, 0) || 0}
              prefix={<DashboardOutlined />}
            />
          </Col>
          <Col span={6}>
            <Statistic
              title={Lang.t('systemLog.statisticsWarningCount')}
              value={statistics.recentAlarms?.filter((log: any) => 
                log.alarmLevel === SystemLogAlarmLevel.WARNING
              ).length || 0}
              prefix={<WarningOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Col>
          <Col span={6}>
            <Statistic
              title={Lang.t('systemLog.statisticsErrorCount')}
              value={statistics.recentAlarms?.filter((log: any) => 
                log.alarmLevel === SystemLogAlarmLevel.ERROR
              ).length || 0}
              prefix={<CloseCircleOutlined />}
              valueStyle={{ color: '#ff4d4f' }}
            />
          </Col>
          <Col span={6}>
            <Statistic
              title={Lang.t('systemLog.statisticsPeriod')}
              value={`${statistics.period || 30}天`}
              prefix={<LineChartOutlined />}
            />
          </Col>
        </Row>
      </Card>
    );
  }

  // 渲染表格列
  renderColumns(): ColumnProps<SystemLog>[] {
    return [
      {
        title: Lang.t('systemLog.module'),
        dataIndex: 'module',
        width: 120,
        render: (text: string, record: SystemLog): React.ReactNode => (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {this.renderModuleIcon(record.module)}
            <span>{record.getModuleText()}</span>
          </div>
        ),
      },
      {
        title: Lang.t('systemLog.operation'),
        dataIndex: 'operation',
        width: 120,
        render: (text: string, record: SystemLog): React.ReactNode => (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {this.renderOperationIcon(record.operation)}
            <span>{record.getOperationText()}</span>
          </div>
        ),
      },
      {
        title: Lang.t('systemLog.user'),
        width: 120,
        render: (text: any, record: SystemLog): React.ReactNode => (
          <div>{record.username}</div>
        ),
      },
      {
        title: Lang.t('log.target'),
        width: 150,
        render: (text: any, record: SystemLog): React.ReactNode => (
          <div>
            <div style={{ fontWeight: 'bold' }}>{record.getTargetTypeText()}</div>
            {record.targetName && (
              <div style={{ fontSize: '12px', color: '#666' }}>
                {record.targetName}
              </div>
            )}
          </div>
        ),
      },
      {
        title: Lang.t('systemLog.detail'),
        dataIndex: 'detail',
        width: 500,
        render: (text: string, record: SystemLog): React.ReactNode => {
          // 如果是系统配置修改，提取变更内容
          let displayText = record.detail;
          
          if (record.module === SystemLogModule.SYSTEM && 
              record.operation === SystemLogOperation.UPDATE &&
              record.detail.includes('修改了基本系统配置')) {
            
            // 提取具体的变更内容
            const parts = record.detail.split(': ');
            if (parts.length > 1) {
              displayText = '系统配置变更: ' + parts[1];
            }
          }
          
          // 如果详情太长，只显示前100个字符
          const truncatedText = displayText.length > 100 
            ? displayText.substring(0, 100) + '...' 
            : displayText;
          
          return (
            <Tooltip 
              title={record.detail}
              placement="topLeft"
              overlayStyle={{ maxWidth: '600px', whiteSpace: 'pre-wrap' }}
            >
              <div 
                style={{ 
                  maxWidth: '500px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  cursor: 'pointer',
                  color: record.module === SystemLogModule.SYSTEM ? '#1890ff' : 'inherit'
                }}
                onClick={() => this.handleViewDetail(record)}
              >
                {truncatedText}
              </div>
            </Tooltip>
          );
        },
      },
      {
        title: Lang.t('systemLog.logType'),
        dataIndex: 'logType',
        width: 100,
        render: (text: string, record: SystemLog): React.ReactNode => (
          <Tag color={record.getLogTypeColor()}>
            {record.getLogTypeText()}
          </Tag>
        ),
      },
      {
        title: Lang.t('systemLog.alarmLevel'),
        dataIndex: 'alarmLevel',
        width: 100,
        render: (text: number, record: SystemLog): React.ReactNode => (
          <Tag color={record.getAlarmLevelColor()}>
            {record.getAlarmLevelText()}
          </Tag>
        ),
      },
      {
        title: Lang.t('systemLog.ip'),
        dataIndex: 'ip',
        width: 120,
        render: (text: string, record: SystemLog): React.ReactNode => (
          <div>{record.ip}</div>
        ),
      },
      {
        title: Lang.t('systemLog.createTime'),
        dataIndex: 'createTime',
        width: 160,
        render: (text: any, record: SystemLog): React.ReactNode => (
          <Tooltip title={DateUtil.simpleDateTime(record.createTime)}>
            <div>{DateUtil.simpleDate(record.createTime)}</div>
          </Tooltip>
        ),
      },
      {
        title: Lang.t('operation'),
        width: 100,
        fixed: 'right',
        render: (text: any, record: SystemLog): React.ReactNode => (
          <AntSpace>
            <Tooltip title={Lang.t('systemLog.viewDetail')}>
              <Button
                type="text"
                size="small"
                icon={<EyeOutlined />}
                onClick={() => this.handleViewDetail(record)}
              />
            </Tooltip>
          </AntSpace>
        ),
      }
    ];
  }

// 渲染高级筛选
renderAdvancedFilter() {
    const { moduleList, operationList } = this.state;
    
    // 确保是数组，防止 map 错误
    const safeModuleList = Array.isArray(moduleList) ? moduleList : [];
    const safeOperationList = Array.isArray(operationList) ? operationList : [];
    
    return (
      <Card className="mb20" title={Lang.t('systemLog.advancedFilter')}>
        <Row gutter={16}>
          <Col span={6}>
            <div className="filter-item">
              <label>{Lang.t('systemLog.module')}</label>
              <Select
                style={{ width: '100%' }}
                placeholder={Lang.t('systemLog.selectModule')}
                value={this.pager.getFilterValue('module') || undefined}
                onChange={(value) => {
                  this.pager.setFilterValue('module', value || null);
                }}
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {safeModuleList.map(item => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
          
          <Col span={6}>
            <div className="filter-item">
              <label>{Lang.t('systemLog.operation')}</label>
              <Select
                style={{ width: '100%' }}
                placeholder={Lang.t('systemLog.selectOperation')}
                value={this.pager.getFilterValue('operation') || undefined}
                onChange={(value) => {
                  this.pager.setFilterValue('operation', value || null);
                }}
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {safeOperationList.map(item => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
          
          <Col span={6}>
            <div className="filter-item">
              <label>{Lang.t('systemLog.logType')}</label>
              <Select
                style={{ width: '100%' }}
                placeholder={Lang.t('systemLog.selectLogType')}
                value={this.pager.getFilterValue('logType') || undefined}
                onChange={(value) => {
                  this.pager.setFilterValue('logType', value || null);
                }}
                allowClear
              >
                <Option value={SystemLogType.NORMAL}>
                  {Lang.t('systemLog.logTypeNormal')}
                </Option>
                <Option value={SystemLogType.WARNING}>
                  {Lang.t('systemLog.logTypeWarning')}
                </Option>
                <Option value={SystemLogType.ERROR}>
                  {Lang.t('systemLog.logTypeError')}
                </Option>
                <Option value={SystemLogType.SECURITY}>
                  {Lang.t('systemLog.logTypeSecurity')}
                </Option>
              </Select>
            </div>
          </Col>
          
          <Col span={6}>
            <div className="filter-item">
              <label>{Lang.t('systemLog.alarmLevel')}</label>
              <Select
                style={{ width: '100%' }}
                placeholder={Lang.t('systemLog.selectAlarmLevel')}
                value={this.pager.getFilterValue('alarmLevel') || undefined}
                onChange={(value) => {
                  this.pager.setFilterValue('alarmLevel', value || null);
                }}
                allowClear
              >
                <Option value={SystemLogAlarmLevel.NONE.toString()}>
                  {Lang.t('systemLog.alarmLevelNone')}
                </Option>
                <Option value={SystemLogAlarmLevel.WARNING.toString()}>
                  {Lang.t('systemLog.alarmLevelWarning')}
                </Option>
                <Option value={SystemLogAlarmLevel.ERROR.toString()}>
                  {Lang.t('systemLog.alarmLevelError')}
                </Option>
                <Option value={SystemLogAlarmLevel.CRITICAL.toString()}>
                  {Lang.t('systemLog.alarmLevelCritical')}
                </Option>
              </Select>
            </div>
          </Col>
          
          <Col span={8}>
            <div className="filter-item">
              <label>{Lang.t('systemLog.timeRange')}</label>
              <RangePicker
                style={{ width: '100%' }}
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                onChange={(dates, dateStrings) => {
                  if (dates && dates.length === 2) {
                    this.pager.setFilterValue('startTime', dateStrings[0]);
                    this.pager.setFilterValue('endTime', dateStrings[1]);
                  } else {
                    this.pager.setFilterValue('startTime', null);
                    this.pager.setFilterValue('endTime', null);
                  }
                }}
              />
            </div>
          </Col>
          
          <Col span={8}>
            <div className="filter-item">
              <label>{Lang.t('user.username')}</label>
              <Input
                placeholder={Lang.t('systemLog.usernamePlaceholder')}
                value={this.pager.getFilterValue('username') || ''}
                onChange={(e) => {
                  this.pager.setFilterValue('username', e.target.value || null);
                }}
                allowClear
                prefix={<UserOutlined />}
              />
            </div>
          </Col>
          
          <Col span={8}>
            <div className="filter-item">
              <label>{Lang.t('systemLog.keyword')}</label>
              <Input
                placeholder={Lang.t('systemLog.keywordPlaceholder')}
                value={this.pager.getFilterValue('keyword') || ''}
                onChange={(e) => {
                  this.pager.setFilterValue('keyword', e.target.value || null);
                }}
                allowClear
                prefix={<SearchOutlined />}
              />
            </div>
          </Col>
          
          <Col span={24}>
            <div className="filter-actions">
              <AntSpace>
                <Button type="primary" icon={<SearchOutlined />} onClick={this.handleSearch}>
                  {Lang.t('systemLog.search')}
                </Button>
                <Button icon={<DeleteOutlined />} onClick={this.handleReset}>
                  {Lang.t('systemLog.reset')}
                </Button>
              </AntSpace>
            </div>
          </Col>
        </Row>
      </Card>
    );
  }
// 在 render 方法中添加详情模态框
renderDetailModal() {
    const { detailVisible, currentDetail, currentLog } = this.state;
    
    if (!detailVisible) return null;
    
    return (
      <Modal

      >
        <div style={{ maxHeight: '500px', overflow: 'auto' }}>
          {currentLog && (
            <>
              <div style={{ marginBottom: '20px' }}>
                <h4>{Lang.t('systemLog.basicInfo')}</h4>
                <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '8px' }}>
                  <div style={{ fontWeight: 'bold' }}>{Lang.t('systemLog.module')}:</div>
                  <div>{currentLog.getModuleText()}</div>
                  
                  <div style={{ fontWeight: 'bold' }}>{Lang.t('systemLog.operation')}:</div>
                  <div>{currentLog.getOperationText()}</div>
                  
                  <div style={{ fontWeight: 'bold' }}>{Lang.t('systemLog.user')}:</div>
                  <div>{currentLog.username}</div>
                  
                  <div style={{ fontWeight: 'bold' }}>{Lang.t('systemLog.ip')}:</div>
                  <div>{currentLog.ip}</div>
                  
                  <div style={{ fontWeight: 'bold' }}>{Lang.t('systemLog.createTime')}:</div>
                  <div>{DateUtil.simpleDateTime(currentLog.createTime)}</div>
                </div>
              </div>
              
              <div>
                <h4>{Lang.t('systemLog.changeDetails')}</h4>
                <div 
                  style={{ 
                    padding: '12px', 
                    backgroundColor: '#f5f5f5',
                    borderRadius: '4px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word'
                  }}
                >
                  {currentDetail}
                </div>
              </div>
              
              {currentLog.extraData && (
                <div style={{ marginTop: '20px' }}>
                  <h4>{Lang.t('systemLog.extraData')}</h4>
                  <pre style={{ 
                    padding: '12px', 
                    backgroundColor: '#f9f9f9',
                    borderRadius: '4px',
                    maxHeight: '200px',
                    overflow: 'auto'
                  }}>
                    {JSON.stringify(currentLog.extraData, null, 2)}
                  </pre>
                </div>
              )}
            </>
          )}
        </div>
      </Modal>
    );
  }
  render() {
    const { exportLoading, cleanLoading } = this.state;

    return (
      <div className="system-log-list">
        {/* 统计卡片 */}
        {this.renderStatistics()}
        
        {/* 操作工具栏 */}
        <Card className="mb20">
          <Row justify="space-between" align="middle">
            <Col>
              <h2>{Lang.t('systemLog.title')}</h2>
            </Col>
            <Col>
              <AntSpace>
                <Button 
                  type="primary" 
                  icon={<ExportOutlined />} 
                  loading={exportLoading}
                  onClick={this.handleExport}
                >
                  {Lang.t('systemLog.export')}
                </Button>
                <Button 
                  danger 
                  icon={<DeleteOutlined />} 
                  loading={cleanLoading}
                  onClick={this.handleClean}
                >
                  {Lang.t('systemLog.clean')}
                </Button>
              </AntSpace>
            </Col>
          </Row>
        </Card>
        
        {/* 高级筛选 */}
        {this.renderAdvancedFilter()}
        
        {/* 日志表格 */}
        <Table
          loading={this.pager.loading}
          dataSource={this.pager.data}
          columns={this.renderColumns()}
          pagination={{
            current: this.pager.page + 1,
            total: this.pager.totalItems,
            pageSize: this.pager.pageSize,
            hideOnSinglePage: false,
            showSizeChanger: true,
            pageSizeOptions: ['20', '50', '100'],
            showTotal: (total) => `${Lang.t('plugin.total')} ${total} ${Lang.t('plugin.items')}`,
          }}
          onChange={this.pager.tableOnChange.bind(this.pager)}
          locale={{
            emptyText: (
              <TableEmpty 
                pager={this.pager} 
                onRefresh={this.refreshPager.bind(this)} 
              />
            ),
          }}
          rowKey="uuid"
          scroll={{ x: 1200 }}
        />
          {this.renderDetailModal()}
      </div>
    );
  }
}